<script>
// Async load the Vue 3 APIs we need from the VUE ESM
import { defineAsyncComponent, defineComponent } from 'vue/dist/vue.esm-bundler';

export default defineComponent({
    components: {
        classnote: defineAsyncComponent(() =>
            import(/* webpackChunkName: "classnotes" */ "@/vue/components/ClassNote.vue")
        ),
        classnoteedit: defineAsyncComponent(() =>
            import(/* webpackChunkName: "classnoteedit" */ "@/vue/components/ClassNoteEdit.vue")
        ),
        forgotpassword: defineAsyncComponent(() =>
            import(/* webpackChunkName: "forgotpassword" */ "@/vue/components/ForgotPassword.vue")
        ),
        login: defineAsyncComponent(() =>
            import(/* webpackChunkName: "login" */ "@/vue/components/Login.vue")
        ),
        profile: defineAsyncComponent(() =>
            import(/* webpackChunkName: "profile" */ "@/vue/components/Profile.vue")
        ),
        register: defineAsyncComponent(() =>
            import(/* webpackChunkName: "register" */ "@/vue/components/Register.vue")
        ),
        contact: defineAsyncComponent(() =>
            import(/* webpackChunkName: "contact" */ "@/vue/components/Contact.vue")
        )
    },
    data: () => ({
    }),
    methods: {
    },
    created(){
    },
    async mounted() {
    }
})

// Example component
// 'hero': defineAsyncComponent(() => import(/* webpackChunkName: "hero" */ '@/vue/components/Hero.vue'))
</script>
